enum ENVIRONMENT {
  'local', 'dev', 'preprod', 'prod', 'localtest'
}

export const LOCALTEST = false; // Set to true when testing backend locally 

const getEnv = () => {
  if(LOCALTEST) {
    console.log("TESTING LOCALLY");
    return ENVIRONMENT.localtest;
  } else {
    const hostname = window && window.location && window.location.hostname;
    switch (hostname) {
      case 'localhost':
        return ENVIRONMENT.local;
      case 'sernetapp.z16.web.core.windows.net':
        return ENVIRONMENT.dev;
      case 'sernet-test.serty.fi':
        return ENVIRONMENT.preprod;
      case 'sernet.serty.fi':
        return ENVIRONMENT.prod;
      default:
        return ENVIRONMENT.local;
    }
  }
}

const LOGIN_URLS = {
  [ENVIRONMENT.local]: 'http://localhost:3000',
  [ENVIRONMENT.dev]: 'https://sernetapp.z16.web.core.windows.net/',
  [ENVIRONMENT.preprod]: 'https://sernet-test.serty.fi/',
  [ENVIRONMENT.prod]: 'https://sernet.serty.fi/',
  [ENVIRONMENT.localtest]: 'http://localhost:3000'
}

const BASE_URLS = {
  [ENVIRONMENT.local]: 'https://serdev-functions.azurewebsites.net',
  [ENVIRONMENT.dev]: 'https://serdev-functions.azurewebsites.net',
  [ENVIRONMENT.preprod]: 'https://seret-functions.azurewebsites.net',
  [ENVIRONMENT.prod]: 'https://sernet-functions.azurewebsites.net',
  [ENVIRONMENT.localtest]: 'http://localhost:7071'
}

const CLIENT_IDS = {
  [ENVIRONMENT.local]: '88e408d4-1ea7-4f31-8129-48ecff68e3f2',
  [ENVIRONMENT.dev]: '88e408d4-1ea7-4f31-8129-48ecff68e3f2',
  [ENVIRONMENT.preprod]: '90945264-ff6d-4ef1-9df3-cb94dc11382a',
  [ENVIRONMENT.prod]: 'fdf428f1-1f4f-41f7-a2e0-17a95d9342e2',
  [ENVIRONMENT.localtest]: '88e408d4-1ea7-4f31-8129-48ecff68e3f2'
}

const TENANT_ID = '37727452-1ffe-4a89-a215-7ad76ed85eb4';

export const getTenantId = () => {
  return TENANT_ID;
}

export const getLoginUrl = () => {
  return LOGIN_URLS[getEnv()];
}

export const getClientId = () => {
  return CLIENT_IDS[getEnv()];
}

export const getFunctionBaseUrl = () => {
  return BASE_URLS[getEnv()];
}
